import React from "react";
import PropTypes from "prop-types";
import { Typography, Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import VesselSelector from "../common/vesselSelector.jsx";
import { GraphSelector } from "./graphSelector.jsx";
import { VESSEL_TYPE } from "../../model/slice/vesselSlice";
import { SEP_CHART_TYPE } from "../../constants/trendGraph/sepLines.js";
import { ENGINE_CHART_TYPE } from "../../constants/trendGraph/enginesLine.js";
import { GraphTypeSelector } from "./graphTypeSelector.jsx";
import { MUIDateTimePicker } from "../dateTimePicker/dateTimePicker.jsx";
import { useTranslation } from "react-i18next";
import localizationKeys from "../../i18n/localizationKeys.js";
import { GRAPH_TYPE } from "../../constants/trendGraph/trendGraphType.js";
import { ELECTRIC_TREND_TYPE } from "../../constants/trendGraph/electricLines.js";
import { ADDITIONAL_ELECTRIC_TREND_TYPE } from "../../constants/trendGraph/additionalElectricTrend.js";

const SELECTOR_WIDTH = 9;

const classes = {
  gridContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "8px",
  },
  main: {
    display: "inline-block",
    fontSize: "10px",
    width: "75%",
  },
  chartSelector: {
    marginTop: "8px",
  },
};

export const ComparisonGraphSelector = (props) => {
  const {
    currentVesselInfo,
    currentSelectedVessel,
    setCurrentSelectedVessel,
    selectedGraphType,
    setSelectedGraphType,
    selectedGraph,
    setSelectedGraph,
    enginePositions,
    setEnginePositions,
    customCharts,
    isFetchingChartInfo,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
  } = props;

  const {t} = useTranslation();

  const graphTypeInitialize = () => {
    const isSepVessel = currentVesselInfo?.vesselType === VESSEL_TYPE.SEP;
    switch (true) {
      case selectedGraphType === GRAPH_TYPE.SEP:
        return SEP_CHART_TYPE;
      case selectedGraphType === GRAPH_TYPE.ENGINE:
          return ENGINE_CHART_TYPE;
      case selectedGraphType === GRAPH_TYPE.ELECTRIC:
        if(isSepVessel) {
          return ADDITIONAL_ELECTRIC_TREND_TYPE
        }else{
          return ELECTRIC_TREND_TYPE;
        }
      default:
        return null;
    }
  };

  return (
    <Grid
      container
      alignItems={"center"}
      justifyContent={"center"}
      spacing={1}
      sx={classes.main}
    >
      <Grid item size={{xs: SELECTOR_WIDTH}} marginBottom={"8px"} fontSize={"10px"} sx={{width: "100%"}}>
        <Box>
          <Typography color="white" fontSize={12}>{t(localizationKeys.StartTime)}</Typography>
          <MUIDateTimePicker isSEPVessel={currentSelectedVessel?.vesselType === VESSEL_TYPE.SEP} date={startDate} setDateFunction={(d) => setStartDate(d)} isStart={true} limitationDate={endDate}/>
          <Typography color="white" fontSize={12}>{t(localizationKeys.EndTime)}</Typography>
          <MUIDateTimePicker currentVessel={currentSelectedVessel?.vesselType === VESSEL_TYPE.SEP} date={endDate} setDateFunction={(d) => setEndDate(d)} isStart={false} limitationDate={startDate}/>
        </Box>
      </Grid>
      <Grid item xs={SELECTOR_WIDTH} sx={classes.gridContainer}>
        <VesselSelector
          currentSelectedVessel={currentSelectedVessel}
          setCurrentSelectedVessel={setCurrentSelectedVessel}
        />
      </Grid>
      <Grid item size={{xs:SELECTOR_WIDTH}} sx={{ minHeight: "35px", width: "100%" }}>
        <GraphTypeSelector 
          selectedVessel={currentVesselInfo} 
          hasCustomCharts={customCharts?.charts?.charts?.length > 0}
          selectedGraphType={selectedGraphType}
          setSelectedGraphType={setSelectedGraphType}
        />
      </Grid>
      {currentSelectedVessel !== null &&
      currentSelectedVessel !== "null" &&
      currentSelectedVessel !== undefined &&
      (
        <Grid item size={{xs: SELECTOR_WIDTH}} sx={classes.gridContainer}>
          <GraphSelector
            vessel={currentVesselInfo}
            selectedGraph={selectedGraph}
            setSelectedGraph={setSelectedGraph}
            selectedEngine={enginePositions}
            setSelectedEngine={setEnginePositions}
            chartType={graphTypeInitialize()}
            position={enginePositions}
            customCharts={customCharts}
            selectedGraphType={selectedGraphType}
            isFetchingChartInfo={isFetchingChartInfo}
          />
        </Grid>
      )}
    </Grid>
  );
};

ComparisonGraphSelector.propTypes = {
  currentVesselInfo: PropTypes.object,
  currentSelectedVessel: PropTypes.string,
  setCurrentSelectedVessel: PropTypes.func,
  selectedGraphType: PropTypes.string,
  setSelectedGraphType: PropTypes.func,
  selectedGraph: PropTypes.string,
  setSelectedGraph: PropTypes.func,
  enginePositions: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  setEnginePositions: PropTypes.func,
  customCharts: PropTypes.object,
  isFetchingChartInfo: PropTypes.bool,
  startDate: PropTypes.string,
  setStartDate: PropTypes.func,
  endDate: PropTypes.string,
  setEndDate: PropTypes.func,
}
